<div class="custom-dialog-wrapper">
    <h1 mat-dialog-title class="custom-dialog-title">Update Item Vendor Relationship</h1>
    <div mat-dialog-content>
        <ng-container *ngIf="tagItemVendorService.tempTagGroup$ | async as tagGroup">
            <div>
                <div class="field-row">
                    <p class="field-label">Item No Set:</p>
                    <p *ngIf="tagGroup.itemNumbers.length === 0" class="text--grey">Not yet selected</p>
                    <p *ngIf="tagGroup.itemNumbers.length > 0">{{ tagGroup.itemNumbers.join(', ') }}</p>
                </div>
                <div class="field-row">
                    <p class="field-label">Vendor Set:</p>
                    <p *ngIf="!tagGroup.vendors">-</p>
                    <p *ngIf="tagGroup.vendors && tagGroup.vendors.length === 0" class="text--grey">Not yet selected</p>
                    <p *ngIf="tagGroup.vendors && tagGroup.vendors.length > 0">{{
                        mapVendorElement(tagGroup.vendors, 'vendorName').join(', ') }}</p>
                </div>
            </div>


            <mat-tab-group class="pt-2" dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab label="Item" bodyClass="mt-0">
                    <app-select-item-table (onSelectedChange)="onItemTableSelectedChange($event)"
                        [selectedItemNumbers]="tagGroup.itemNumbers"
                        [filterItemNumbers]="getFilterItemNumbers()" [isScrollWithinTable]="true"></app-select-item-table>

                </mat-tab>
                <mat-tab label="Vendor" bodyClass="mt-0">
                    <section class="section--vendor mt-3">
                        <div>
                            <div class="field-info">
                                <p class="mb-1 paragraph-medium-regular"> Do you have vendors to tag? </p>
                            </div>
                            <mat-button-toggle-group (change)="onHasVendorTagChange($event)"
                                [value]="tagGroup.vendors ? HasVendorTag.YES : HasVendorTag.NO">
                                <mat-button-toggle [value]="HasVendorTag.YES">Yes</mat-button-toggle>
                                <mat-button-toggle [value]="HasVendorTag.NO">No</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>

                        <div class="form-field mt-4">
                            <p class="mb-1 paragraph-medium-regular">Sourcing Status</p>
                            <ng-select class="form-field--sourcing-status" [ngModel]="tagGroup.sourcingStatusId"
                                [items]="sourcingStatusOptions"
                                appearance="outline" bindLabel="name" bindValue="id"
                                (change)="onSourcingStatusChange($event)" [readonly]="!!tagGroup.vendors">
                                <ng-template ng-option-tmp let-item="item">
                                    <div
                                        [ngClass]="{'is-hidden': item.id === SourcingStatusId.POTENTIAL_VENDOR_IDENTIFIED 
                                        && tagGroup.sourcingStatusId !== SourcingStatusId.POTENTIAL_VENDOR_IDENTIFIED}">
                                        {{ item.name }}
                                    </div>
                                </ng-template>
                            </ng-select>
                        </div>
                        <ng-container *ngIf="tagGroup.vendors">
                            <div class="mt-3">
                                <app-select-vendor-table (onSelectedChange)="onVendorTableSelectedChange($event)"
                                    [selectedVendorNumbers]="mapVendorElement(tagGroup.vendors, 'vendorNumber')" [isScrollWithinTable]="true"></app-select-vendor-table>
                            </div>
                        </ng-container>
                    </section>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
    </div>
    <div mat-dialog-actions class="custom-dialog-buttons">
        <app-button class="padBtn cancel-button" name="Cancel" mat-dialog-close></app-button>
        <app-button class="padBtn action-button" name="Update" type="flat-button" cdkFocusInitial
            (click)="onDialogAction()"></app-button>
    </div>
</div>